import React from 'react'
import { motion } from 'motion/react'

import coverimage from 'assets/images/uam/dietetica-adolescentes-a.webp'

export default props => {
  
  const container = {
    hidden: { 
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        duration: 0,
        staggerChildren: 0.3
      }
    }
  }

  const item = {
    hidden: {
      opacity: 0,
      translateY: '100px'
    },
    show: {
      opacity: 1,
      translateY: '0px',
      transition: {
        duration: 0.5
      }
    }
  }
  
  return <motion.div 
    className="cover"
    variants={container}
    initial="hidden"
    animate="show"
  >
    <motion.div 
      className="image"   
      variants={ item }
    >
      <img src={ coverimage } />
    </motion.div>
    <motion.div 
      className="text"   
      variants={ item }
    >
      ¿Preparado para el reto semanal?
    </motion.div>
    <motion.div
      className="enter"   
      variants={ item }
    >
      <button
        onClick={ 
          () => props.dispatch({
            inexit: true,
            play: true
          })
        }
      >
        Sí, vamos allá!
      </button>
    </motion.div>
  </motion.div>
}
